import { noProps } from "./shared";

export const map = {
  "Begin measuring": noProps.describe("User clicked on the measure button on the map to start measuring"),
  "End measuring": noProps.describe("User clicked on the measure button on the map to stop measuring"),
  "Clicked measure distance button": noProps.describe("REDUNDANT: User clicked on the Measure Distance button on the map"),
  "Clicked zoom in button": noProps.describe("User clicked on the Zoom In button on the map"),
  "Clicked zoom out button": noProps.describe("User clicked on the Zoom Out button on the map"),
  "Clicked zoom to design button": noProps.describe("User clicked on the Zoom To Design button on the map"),

  "Opened feature popup": noProps.describe("User clicked on a single feature for a comment or a feature. "),
  "Opened features selection popup": noProps.describe(
    "User clicked a feature selection popup on the map, this happens when features are close together on the map"
  ),
  "Opened map feature selection popup": noProps.describe("REDUNDANT: Fired programmatically when the features selection popup is triggered"),
  "Opened map popup": noProps.describe("User opened the properties panel. This event fires for programmatic opens of the feature popup"),
  "map.controls.streetview.clicked": noProps.describe("User clicked on the Street View button within the map toolbar"),
};
